var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-pages"},[_c('div',{staticClass:"empty-box"},[_c('img',{staticClass:"image-logo",attrs:{"alt":"logo","src":require("../assets/logo.png")}}),_c('span',{staticClass:"empty-text"},[_vm._v("敬请期待...")])])])
}]

export { render, staticRenderFns }